import { sequenceSingleModal } from './sequenceSingleModal'
import { updateNodeConnections } from '../../functions/utils'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { value: sequenceSingleData } = await sequenceSingleModal(oldData, node)

  if (sequenceSingleData && Object.values(sequenceSingleData).length >= 0) {
    Object.assign(node.data, sequenceSingleData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}